<template>
  <section class="lms-container">
    <div class="content">
    <div class="breadcrumb" style="border: none !important;"></div>

      <tabs>
        <tab v-if="userType==0" title="Dashboard">
          <dashboard v-if="dailyChartData" :dailyChartData="dailyChartData" />
        </tab>
        <tab title="Progresso">
          <student-report
            @getStudentData="getStudentData"
            :users="users"
            :courses="courses"
            :studentData="studentData"
            :loadingData="loadingData"
          />
        </tab>
        <tab v-if="userType!=2" title="Pagamentos">
          <payments-report
            @getPaymentData="getPayments"
            :users="users"
            :courses="courses"
            :paymentData="payments"
            :loadingData="loadingData"
          />
        </tab>
        <tab v-if="userType==0" title="Ativos">
          
        <div style="display: flex; flex-direction: row; padding: 0 2.5rem">
          <div class="control-group" style="flex: 1">
            <label class="control-label" for="issuanceDate" style="color:black; padding-left: 3%">Mês / Ano</label>
            <v-mp style="color:black;  width: 40px; padding-left: 3%" id="monthly-picker" 
            v-bind:monthLabels="monthLabels" 
            v-bind:placeHolder="placeHolder"
            v-bind:selectedBackgroundColor="selectedBackgroundColor"
            v-bind:dateFormat="dateFormat"
            @selected="getPresence(null, $event.format('MM/YYYY'))">
            </v-mp>
          </div>

          <div class="control-group" style="flex: 1">
            <label class="control-label" for="course">Curso</label>
            <select
              @change="onChange($event)"
              v-model="course"
              id="course"
              class="form-control"
              placeholder="Escolha um curso"
            >
            <option :value="null">Selecionar Curso</option>
            <option
              v-for="course in courses"
              v-bind:key="course.id"
              v-bind:value="course.id"
            >{{course.name}}</option>
            </select>
          </div>
          <div style="flex: 1; text-align: right; font-weight: bold">N° Alunos: {{this.actives.length}}</div>
        </div>

        <actives-report :activesData="actives" :loadingData="loadingData" />
          
        </tab>
        <tab v-if="userType==0" title="Inativos">
          <inactives-report :inactivesData="inactives" :loadingData="loadingData" />
        </tab>
      </tabs>
    </div>
  </section>
</template>

<style lang="scss" scoped>

.vue-monthly-picker .month-year-display:hover {
    height: 34px;
}
</style>

<script>
import axios from "axios";
import StudentReport from "./Student";
import PaymentsReport from "./Payments";
import ActivesReport from "./Actives";
import InactivesReport from "./Inactives";
import Dashboard from "./Dashboard";
import VueMonthlyPicker from 'vue-monthly-picker';

export default {
  data() {
    return {
      userType: this.$store.getters.user.type,
      userId: this.$store.getters.user.id,
      selectedStudent: 0,
      selectedCourse: 0,
      studentData: [],
      users: [],
      courses: [],
      course: null,
      payments: [],
      actives: [],
      placeHolder: ((new Date().getMonth()+1) < 10 ? "0" +(new Date().getMonth()+1) : (new Date().getMonth()+1)) + "/" + (new Date().getFullYear()), 
      inactives: [],
      paymentChartData: null,
      dailyChartData: null,
      loadingData: false,
      monthLabels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      dateFormat: "MM/YYYY",
      selectedBackgroundColor: "blue",
      selectedCourse: null
    };
  },
  components: {
    Dashboard,
    ActivesReport,
    InactivesReport,
    StudentReport,
    PaymentsReport,
     'v-mp' : VueMonthlyPicker
  },
  methods: {
    studentProgress(watched, total) {
      return (watched / total) * 100 + "%";
    },
    getStudentData(selectedStudentId, selectedCourseId) {
      this.loadingData = true;
      const path = this.$global.endpoint + "/analytics/getstudentdata";
      axios
        .post(path, {
          userId: selectedStudentId,
          courseId: selectedCourseId
        })
        .then(res => {
          this.studentData = res.data;
          this.loadingData = false;
        })
        .catch(error => {
          console.error(error);
          this.loadingData = false;
        });
    },
    getUsers() {
      const path = this.$global.endpoint + "/user/admin/getall";
      axios
        .post(path, {
          type: 1
        })
        .then(res => {
          this.users = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    getCourses() {
      const path = this.$global.endpoint + "/course/getall";
      
      axios
        .get(path)
        .then(res => {
          this.courses = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    getPayments(userId) {
      const path = this.$global.endpoint + "/payment/getall";
      axios
        .post(path, {
          userId: userId
        })
        .then(res => {
          this.payments = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    getPresence(courseId = null, date = ((new Date().getMonth()+1) < 10 ? "0" +(new Date().getMonth()+1) : (new Date().getMonth()+1)) + "/" + (new Date().getFullYear())) {

      courseId = this.selectedCourse;
      let userId = this.userId;

      date =  date.split('/');
      
      const path = this.$global.endpoint + `/presence`;
      
      this.placeHolder = date[0] + '/' + date[1];
      axios
        .get(path, {
          params: {
            courseId: courseId,
            month: parseInt(date[0]),
            year: parseInt(date[1])
          }
        })
        .then(res => {
          this.actives = res.data;
          console.log(this.actives)
        })
        .catch(error => {
          console.error(error);
        });
    },
    getInactives() {
      const path = this.$global.endpoint + "/user/getinactives";
      axios
        .get(path)
        .then(res => {
          this.inactives = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    getPaymentData() {
      this.$store.dispatch("loadProductSales");
      this.$store.dispatch("loadMonthSales");
      this.$store.dispatch("loadPaymentRate");
      /*
      const path = this.$global.endpoint + "/analytics/getpaymentdata";
      axios
        .post(path, {
          allProducts:true
        })
        .then(res => {
          this.paymentChartData = res.data;
        })
        .catch(error => {
          console.error(error);
        });
        */
    },
    getDailyPaymentData() {
      const path = this.$global.endpoint + "/analytics/getpaymentdata";
      axios
        .post(path, {
          allProducts: false
        })
        .then(res => {
          this.dailyChartData = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    onChange(event){
      this.selectedCourse = event.target.value;
      this.getPresence(this.selectedCourse);
    }
  },
  created() {
    this.getStudentData();
    this.getUsers();
    this.getCourses();
    this.getPayments();
    this.getPresence();
    this.getInactives();
    this.getPaymentData();
    this.getDailyPaymentData();
  }
};
</script>
